import actions from "actions";
import { UserListWebinar } from "components/AddUsersWebinar/UserListWebinar.jsx";
import ToolbarNewWebinar from "components/AddUsersWebinar/index";
import PropTypes from "prop-types";
import React, { Component } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { connect } from "react-redux";
import {
  getAdminGroupMembers,
  getGroupInvites,
  getGroupMembers,
} from "../../../actions/studygroups";

const {
  showDeleteUsersConfirmationModal,
  adminUserFilter,
  setTempWebinar,
  adminPostAssignedUsersSaga,
} = actions;

const roles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  {},
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
  // { value: "registered_general_nurses", label: "Registered General Nurse" },
];

class AddGroupWebinarUsers extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.timer = true;

    this.state = {
      user_ids: (props.webinar && props.webinar.assigned_ids) || [],
      per_page: 50,
      page: props.page || 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
        ...props.query,
      },
      startDate: null,
      endDate: null,
      search: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.total_pages != this.props.total_pages)
      this.setState({
        page: 1,
      });
  }

  componentWillMount = () => {
    this.updateUsersList();
  };

  deleteUsers = () => {
    if (this.state.user_ids.length > 0)
      this.props.deleteUsers(this.state.user_ids);
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.updateUsersList
    );
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const searchQuery = {
      ...this.state.searchQuery,
      order: {
        [field]: order,
      },
    };
    this.setState(
      {
        searchQuery,
      },
      this.updateUsersList
    );
  };

  checkedUserIds = (user_id) => {
    let ids = this.state.user_ids.map(Number);
    // var ids = _.assign(this.state.user_ids).map(Number),
    //   index = this.state.user_ids.indexOf(user_id);

    if (ids.includes(user_id)) {
      ids = ids.filter((id) => id !== user_id);
    } else {
      ids = [...ids, user_id];
    }

    this.setState({ user_ids: ids });
  };

  changeFilterQuery = (field, value) => {
    // const query = { ...this.state.searchQuery, ...{ [field]: value } };
    this.setState({ search: value, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.searchQuery,
      ...{
        [`${field}_from`]: start,
        [`${field}_to`]: end,
      },
    };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  updateUsersList = () => {
    const { page, per_page, search, searchQuery } = this.state;

    const { order } = searchQuery;

    const [field, direction] = Object.entries(order)[0];

    this.props.getGroupMembers(this.props.params.id, {
      page,
      per_page,
      search,
      order: field,
      direction,
    });
  };

  onAddCheckedUsersClick = () => {
    this.props.setTempWebinar({
      ...this.props.webinar,
      ...{
        assigned_ids: this.state.user_ids,
      },
    });

    if (this.props.webinar.id) {
      return this.props.router.push({
        pathname: `/groups/${this.props.params.id}/webinars/${this.props.webinar.id}`,
        state: { from: "addUsersWebinar" },
      });
    }

    this.props.router.push({
      pathname: `/groups/${this.props.params.id}/webinars/new`,
      state: { from: "addUsersWebinar" },
    });
  };

  render() {
    const { changeFilterQuery, setState, deleteUsers, onDateRangeChange } =
      this;

    const { count, total_pages, values } = this.props.users;

    const userIds = this.state.user_ids.map(Number);

    return (
      <main className="site--width container_statistics">
        <ToolbarNewWebinar
          filterProps={{
            ...this.state,
            changeFilterQuery,
            setState,
            roles,
            onDateRangeChange,
          }}
          toolsProps={{
            ...this.state,
            onAddCheckedUsersClick: this.onAddCheckedUsersClick,
            deleteUsers,
            count,
          }}
        />
        <div className="admin_user_table admin_table">
          <UserListWebinar
            onOrderChange={this.onOrderChange}
            query={this.state.searchQuery}
            users={values}
            checkedUserIds={this.checkedUserIds}
            user_ids={userIds}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              // total_pages: totalPages,
              total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function sortByIncludedInArray(sortArray, arrayIncludedIn) {
  return sortArray.sort(
    (a, b) =>
      isIncludedIn(arrayIncludedIn, b.id) - isIncludedIn(arrayIncludedIn, a.id)
  );
}

function isIncludedIn(array, item) {
  return array.map(Number).indexOf(item) > -1;
}

function mapStateToProps(state) {
  return {
    webinar: state.webinars.tmp,
    users: state.studygroups.groupMembers,
    assignedUsers: state.users.assignedUsers.values,
    count: state.users.assignedUsers.count,
    total_pages: state.users.assignedUsers.total_pages,
    page: state.users.assignedUsers.page,
    query: state.users.assignedUsers.query,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    setTempWebinar: (webinar) => dispatch(setTempWebinar(webinar)),
    deleteUsers: (user_ids) =>
      dispatch(showDeleteUsersConfirmationModal(user_ids)),
    userFilter: (query, page) => dispatch(adminUserFilter(query, page)),
    adminPostAssignedUsersSaga: (assigned_users, page, query) =>
      dispatch(adminPostAssignedUsersSaga(assigned_users, false, page, query)),
    getGroupMembers: (id, params) => dispatch(getAdminGroupMembers(id, params)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddGroupWebinarUsers);



// WEBPACK FOOTER //
// ./src/components/Admin/AddGroupWebinarUsers/index.jsx